module.exports = __webpack_public_path__ + "media/images/laurent-4ba502a7.png";